import moment from "moment"
import Colors from "../../../constants/Colorsv2"
import { PublicPlayerProps } from "../../../store/types/auth_svc"
import { TradeProps } from "../../../store/types/mk_svc"
import { EventProps } from "../../../store/types/sr_svc"
import { CompetitionMatchMarketProps, CompetitionMatchProps, CompetitionPayoutTypeProps, CompetitionPlayerProps, CompetitionProps, CompetitionResultProps, CompetitionResultTypeProps, CompetitionSeasonProps, CompetitionTypeProps, CreateCompetitionProps } from "../../../store/types/tp_svc"

export type WizardStepProps = {
    number: number, 
    label:string,
    description:string,
    status: 'active'|'inactive'|'complete'
}

export const comp_getNewCompSteps = ():WizardStepProps[] => {
    return [
        { number: 1, label: 'Competition Basics', description:'To create a new competition we need some basic details to get it setup.', status:'active' },
        { number: 2, label: 'Add Events', description:'You can now add the events you wish your participants to compete on.', status:'inactive' },
        { number: 3, label: 'Set Ticket Price And Start Time', description:'Specify how much it costs to enter your competition and when it starts.', status:'inactive' },
        { number: 4, label: 'Congratulations', description:'Share your competition with other users or on your socials.', status:'inactive' }
    ]
}

export const help_isSeasonValid = (s:CompetitionSeasonProps, result_type?:CompetitionResultTypeProps, type?:CompetitionTypeProps) => {
    if(!s.season_name){ return false }
    if(!s.season_description){ return false }
    if(!s.competition_result_type_id){ return false }
    if(!result_type){ return false }
    if(!type){ return false }
    if(type.type == 'pick' && s.max_picks <= 0 ){ return false }
    if(type.type == 'wager' && s.initial_balance <0) { return false }
    if(result_type.type == 'outpace' && !s.pacer_id || s.pacer_id == ''){ return false }
    return true
}

export const help_getEmptyCompetitionSeason = ():CompetitionSeasonProps => {
    return {
        competition_season_id:'',
        season_name:'',
        season_description: '',
        image: { url: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1692636804/be-logo-white_c6bxsc.webp' },
        payout_allocation:1,
        payout_amt: 0,
        ticket_price: 25,
        allow_late_buy_in: false,
        single_buy_in: true,
        competition_result_type_id: '1',
        competition_type_id: '1',
        max_picks: 10,
        initial_balance: 1000,
        unallocated_funds: 0,
        balance_rollover: false,
        admin_id:'',
        expected_competition_count: 0,
        status: 'active',
        scheduled_datetime: moment().add(10, 'days'),
        create_datetime:'',
        last_update_datetime:'',
        market_type: 'FOR_MONEY'
    }
}


export const comp_getCompetitionMatchFromEvent = (event:EventProps):CompetitionMatchProps => {
    return {
        event_id:event.event_id,
        event_type: 'team',
        competition_match_id: '',
        competition_id: '',
        create_datetime:'',
        last_update_datetime: '',
        status:'inprogress'
    }
}

export const comp_getCompetitionPlayerFromPlayer = (player:PublicPlayerProps):CompetitionPlayerProps => {
    return {
        competition_id:'',
        competition_player_id:'',
        player_id: player.player_id,
        wager_based_balance: 1000,
        accepted_ind: false,
        status: 'invited',
        create_datetime: '',
        last_update_datetime: ''
    }
}

export const comp_getCompMatchMarketsFromTrades = (trades:TradeProps[], market_ids:string[]):CompetitionMatchMarketProps[] => {
    let filtered_trades = trades.filter(t => t.market_type == 'FOR_MONEY' && market_ids.map(id => id.toString()).includes(t.market_id.toString()))
    let cmm:CompetitionMatchMarketProps[] = []
    filtered_trades.map(t => {
        cmm.push({
            event_id:t.event_id,
            event_type: t.event_type,
            competition_match_id:'',
            competition_match_market_id: '',
            var_1: t.var_1,
            side:t.side,
            side_id: t.side_id,
            odds: t.odds,
            probability: t.probability,
            market_id: t.market_id,
            status: 'active',
            create_datetime:'',
            last_update_datetime:''
        })
    })
    return cmm
}

export const comp_getStartTimeOptions = (draft_competition:CreateCompetitionProps, events:EventProps[]) => {
    let available_picks = (draft_competition.competition_match_markets.length / 2) + draft_competition.additional_markets.length
    let included_events = events.filter(e => draft_competition.competition_matches.map(cm => cm.event_id.toString()).includes(e.event_id.toString()))
    let additional_market_events = events.filter(e => draft_competition.additional_markets.map(m => m.event_id.toString()).includes(e.event_id.toString()))
    included_events = included_events.concat(additional_market_events).sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())
    let start_time_options:{ start_time:string, label:string }[] = []
    let earliest_event = included_events[0]
    start_time_options.push({ start_time: earliest_event.scheduled_datetime, label: `Start time of the earliest game` })
    if(available_picks === draft_competition.competition.max_pick_count){
        return start_time_options
    }
    let diff = available_picks - draft_competition.competition.max_pick_count
    let picks_per_event = available_picks / included_events.length
    let event_to_back = diff / picks_per_event
    earliest_event = included_events[Math.ceil(event_to_back)]
    if(!earliest_event){ return start_time_options }
    start_time_options.push({ label: 'Latest start time possible based on max picks', start_time: earliest_event.scheduled_datetime })
    return start_time_options
}

export const comp_getEndTime = (draft_competition:CreateCompetitionProps, events:EventProps[]) => {
    let included_events = events.filter(e => draft_competition.competition_matches.map(cm => cm.event_id.toString()).includes(e.event_id.toString()))
    let additional_market_events = events.filter(e => draft_competition.additional_markets.map(m => m.event_id.toString()).includes(e.event_id.toString()))
    included_events = included_events.concat(additional_market_events).sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())
    if(included_events.length === 0){ return undefined }
    return moment(included_events[included_events.length - 1].scheduled_datetime).add(4, 'hours')
}

export const comp_getEmptyCompetition = (admin_id:string):CreateCompetitionProps => {
    let competition:CompetitionProps = {
        competition_id:'',
        competition_name:'',
        competition_description:'',
        competition_code: '',
        competition_type_id: '1',
        competition_result_type_id: '1',
        buy_in:10,
        invite_followers:false,
        admin_id: '',
        status:'scheduled',
        end_datetime: '',
        scheduled_datetime: '',
        create_datetime:'',
        last_update_datetime:'',
        leagues: [],
        market_ids: [],
        available_tickets: 10,
        max_pick_count: 0,
        tickets_sold: 0,
        ticket_revenue: 0,
        entered: false,
        premium_only: false,
        market_type: 'FREE',
        length_type:'event',
        invite_only: false,
        initial_balance: 1000
    }
    return { competition, competition_matches:[], competition_match_markets: [], additional_markets:[], competition_players:[], updated:moment().unix() }
}


export const comp_isCompOptionsValid = (competition:CompetitionProps, competition_types:CompetitionTypeProps[], competition_result_types:CompetitionResultTypeProps[]):string[] => {
    let errors:string[] = []
    if(!competition.competition_name || competition.competition_name === ''){ errors.push('Competition must have a name') }
    if(!competition.competition_result_type_id || !competition.competition_type_id){ errors.push('Invalid competition types') }
    let comp_type = competition_types.find(ct => ct.competition_type_id == competition.competition_type_id)
    if(!comp_type){ errors.push('Not a valid competition type') }
    if(isNaN(competition.available_tickets) || competition.available_tickets < 0){ errors.push('Invalid available ticket amount') }
    let comp_result_type = competition_result_types.find(ct => ct.competition_result_type_id == competition.competition_result_type_id)
    if(!comp_result_type){ errors.push('Not a valid result type') }
    if(comp_result_type && comp_result_type.type === 'outpace' && !competition.pacer_id){ errors.push('Outpace competitions require a pacer') }
    if(comp_result_type && comp_result_type.type !== 'outpace' && competition.pacer_id){ errors.push('Pacer must not be included with this result type') }
    if(competition.promo_payout && competition.promo_payout > 0 && !competition.sponsor_id){ errors.push('Only sponsored competitions can include a promo payout') }
    return errors
}

export const comp_isCompEventsValid = (draft_competition:CreateCompetitionProps) => {
    let errors:string[] = []
    let comp_matches = draft_competition.competition_matches.length
    let comp_match_markets = draft_competition.competition_match_markets.length
    let markets = draft_competition.competition.market_ids.length
    if(comp_matches === 0 && draft_competition.additional_markets.length == 0){ errors.push('Must include at least 1 event') }
    //if(comp_matches * markets != comp_match_markets / 2) { errors.push('Invalid markets') }
    return errors
}


export const comp_getCompColors = (competition_type?:CompetitionTypeProps, competition?:CompetitionProps) => {
    if(competition?.premium_only){
        return { backgroundColor:Colors.incentive.gold_faded, borderColor:Colors.incentive.gold }
    }
    switch(competition_type?.type){
        case 'pick': return { backgroundColor:'rgba(26,205,106,0.1)', borderColor:Colors.highlights.highlight400 }
        case 'wager': return { backgroundColor:'rgba(59,26,205,0.1)', borderColor:Colors.highlights.highlight100 }
        default: return { backgroundColor:Colors.brand.slate, borderColor:Colors.shades.black }
    }
}




export const comp_formatPlace = (place:number):string => {
    switch(place){
        case 1: return `1st`
        case 2: return '2nd'
        case 3: return '3rd'
        case 4: return '4th'
        case 5: return '5th'
        case 6: return '6th'
        case 7: return '7th'
        case 8: return '8th'
        case 9: return '9th'
        default: return `${place}`
    }
}